<template>
  <div>
    <div class="card height-100">
      <header class="header-card">
        <p>{{ $t('modificationOrdreTravailAffichage.popUpAjoutFace.titleBox')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline"
          v-if='annonceur.indexRegroupement !== indexRegroupementManuel'>
          <div class="column is-5">
            <b-field :label="$t('modificationOrdreTravailAffichage.popUpAjoutFace.annonceurInfo')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ annonceur.annonceurs }}</p>
            </b-field>
          </div>
          <div class="column" :class="'is-7'">
            <b-field :label="$t('modificationOrdreTravailAffichage.popUpAjoutFace.themeInfo')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ annonceur.theme }}</p>
            </b-field>
          </div>
        </div>
        <div class="columns is-multiline" v-else>
          <div class="column is-12">
            <b-field :label="$t('modificationOrdreTravailAffichage.popUpAjoutFace.poseInfo')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ annonceur.theme }}</p>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { INDEX_REGROUPEMENT_MANUEL } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export default {
  name: 'infoOtAnnonceur',
  data() {
    return {
      indexRegroupementManuel: INDEX_REGROUPEMENT_MANUEL,
    };
  },
  props: {
    annonceur: {
      type: Object,
      required: true,
    },
  },
  components: {
  },
};
</script>

<style scoped>

</style>
